const ACCEPTANCE_TEST_COOKIE = 'hs_selenium';
export const setLSDataForAT = (data, keyWord) => {
  if (document.cookie.includes(ACCEPTANCE_TEST_COOKIE)) {
    try {
      localStorage.setItem('configure2faData', JSON.stringify(data[keyWord]));
    } catch (e) {
      console.log(e);
    }
  }
};